import { useFeatureFlags } from '@/hooks/featureFlag/useFeatureFlags';
import { useGreyScoutAdminAccess } from '@/hooks/shared/useIsGreyScoutAdmin';
import { useIsOnInstance } from '@/hooks/shared/useIsOnInstance';

/**
 * Whether in-app notifications are shown at all - the bell, the page and the fetching behind them.
 *
 * A Grey Scout Admin's notifications are their own wherever they sign in, so on another company's
 * instance they would look like that company's. They are shown on the admin instance only, and
 * held back elsewhere until the user is known not to be one.
 */
export const useInAppNotificationsAvailable = () => {
  const { isInAppNotificationsEnabled } = useFeatureFlags();
  const { isAdminInstance } = useIsOnInstance();
  const { isGreyScoutAdmin, isLoading } = useGreyScoutAdminAccess();

  if (!isInAppNotificationsEnabled) {
    return false;
  }

  if (isAdminInstance) {
    return true;
  }

  return !isLoading && !isGreyScoutAdmin;
};
